import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../state/actions/userActions';


import {
  QtmHeader,
  QtmHeaderBrand,
  QtmHeaderMenu,
  QtmDropdown,
  QtmButton,
  QtmTabs,
  QtmTab,
  QtmHeaderMenuLeft,
  QtmHeaderMenuRight,
  QtmDropdownTrigger,
  QtmDropdownOverlay,
  QtmMenuItemList,
  QtmMenuItem,
  QtmMenuItemLabel,
  QtmIcon
} from '@qtm/react';

import ClockDisplayComponent from './ClockDisplayComponent';
import { logout } from '../auth/auth';
function Header({ userName }) {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user.userInfo);

  const handleLogout = () => {
    dispatch(logoutUser());
  };
  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <div className="">

      <QtmHeader size="medium" classes="header">
        <QtmHeaderBrand classes="header-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/43/Thales.svg"
            alt="thales logo"
          />
        </QtmHeaderBrand>
        <QtmHeaderMenu classes="overflow-x-clip">
          <QtmHeaderMenuLeft classes="hidden medium:flex overflow-x-auto">
            <QtmTabs divider fullHeight scrollHorizontally size="medium">
              <QtmTab active classes="header-tab">TopSky - Flow Manager PUBLISHED MEASURES</QtmTab>
            </QtmTabs>
          </QtmHeaderMenuLeft>
          <QtmHeaderMenuRight classes="flex items-center s">
            <QtmDropdown>
              <QtmDropdownTrigger>

                <QtmButton className= {`mt-1 username-shift-left ${
              isMenuOpen ? 'menu-open' : ''
            }`} variant="ghost" color="primary" size="medium"    onClick={() => setIsMenuOpen(!isMenuOpen)} 
              >
                {userInfo?.name ?? ''} </QtmButton>
              
              </QtmDropdownTrigger>
              <QtmDropdownOverlay className="relative mt-1 menu-shift-left shadow-xl-strong bg-white rounded-lg">
            
              <div
                className={`menu-triangle ${
                  isMenuOpen ? 'menu-triangle-visible' : ''
                }`}
              ></div>
                <QtmMenuItemList classes="medium">
                  <QtmMenuItem>
                    <QtmMenuItemLabel>
                      <div className="flex items-center ">
                        <QtmIcon icon="account_circle" className="mr-2 " />
                        Manage Account
                      </div>
                    </QtmMenuItemLabel>
                  </QtmMenuItem>
                  <div className="user-menu-seperator" />
                  <QtmMenuItem >
                    <QtmMenuItemLabel onClickEvent={logout} >Log out</QtmMenuItemLabel>
                  </QtmMenuItem>
                </QtmMenuItemList>
              </QtmDropdownOverlay>
            </QtmDropdown>
            <div className="clock-display">
              <ClockDisplayComponent
                currentTime={{
                  deltaTime: 0,
                  status: 'RUNNING',
                  time: 1598963696000
                }}
              />
            </div>

          </QtmHeaderMenuRight>
        </QtmHeaderMenu>
      </QtmHeader>
    </div>
  );
}

export default Header;
